/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/move_medium'
export default icon
